import React, { useEffect, useState } from 'react';
import { collection, query, where, orderBy, onSnapshot, getDocs } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { getAuth } from 'firebase/auth';
import { Link, useNavigate } from 'react-router-dom';
import './ActiveBolos.css';
import { saveToGallery, formatSaveMessage } from '../utils/saveToGallery';


const ActiveBolos = () => {
  const auth = getAuth();
  const navigate = useNavigate();
  const [bolos, setBolos] = useState([]);
  const [readBolos, setReadBolos] = useState(() => JSON.parse(localStorage.getItem('readBolos')) || []);
  const [currentUser, setCurrentUser] = useState(null);
  const [expandedBolos, setExpandedBolos] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);



  useEffect(() => {
    const cachedProfile = localStorage.getItem('currentUserProfile');
    if (cachedProfile) setCurrentUser(JSON.parse(cachedProfile));
  }, []);

  useEffect(() => {
  if (!currentUser?.agency) return;

  const now = Date.now();

  const q = query(
    collection(db, 'bolos'),
    where('recipients', 'array-contains', currentUser.agency),
    orderBy('createdAt', 'desc')
  );

  const unsubscribe = onSnapshot(q, (snapshot) => {
    const active = snapshot.docs.map(doc => {
      const data = doc.data();
      const createdAt = data.createdAt.toDate();
      const expirationMs = Number(data.expiration) * 60 * 60 * 1000;
      const expiresAt = createdAt.getTime() + expirationMs;
      const remainingMs = expiresAt - Date.now();

      return remainingMs > 0
        ? {
            id: doc.id,
            ...data,
            createdAt,
            expiresAt
          }
        : null;
    }).filter(Boolean);

    setBolos(active);
  });

  return () => unsubscribe();
}, [currentUser]);




  useEffect(() => {
    const interval = setInterval(() => {
      setBolos(prev => prev.filter(bolo => bolo.expiresAt > Date.now()));
    }, 60000);

    return () => clearInterval(interval);
  }, []);



	const stateAbbreviations = {
  'Alabama': 'AL', 'Alaska': 'AK', 'Arizona': 'AZ', 'Arkansas': 'AR',
  'California': 'CA', 'Colorado': 'CO', 'Connecticut': 'CT', 'Delaware': 'DE',
  'Florida': 'FL', 'Georgia': 'GA', 'Hawaii': 'HI', 'Idaho': 'ID',
  'Illinois': 'IL', 'Indiana': 'IN', 'Iowa': 'IA', 'Kansas': 'KS',
  'Kentucky': 'KY', 'Louisiana': 'LA', 'Maine': 'ME', 'Maryland': 'MD',
  'Massachusetts': 'MA', 'Michigan': 'MI', 'Minnesota': 'MN', 'Mississippi': 'MS',
  'Missouri': 'MO', 'Montana': 'MT', 'Nebraska': 'NE', 'Nevada': 'NV',
  'New Hampshire': 'NH', 'New Jersey': 'NJ', 'New Mexico': 'NM', 'New York': 'NY',
  'North Carolina': 'NC', 'North Dakota': 'ND', 'Ohio': 'OH', 'Oklahoma': 'OK',
  'Oregon': 'OR', 'Pennsylvania': 'PA', 'Rhode Island': 'RI', 'South Carolina': 'SC',
  'South Dakota': 'SD', 'Tennessee': 'TN', 'Texas': 'TX', 'Utah': 'UT',
  'Vermont': 'VT', 'Virginia': 'VA', 'Washington': 'WA', 'West Virginia': 'WV',
  'Wisconsin': 'WI', 'Wyoming': 'WY'
};

const abbreviateState = (state) => stateAbbreviations[state] || state;




  const handleExpand = (id) => {
   if (!expandedBolos.includes(id)) {
  setExpandedBolos(prev => [...prev, id]);
} else {
  setExpandedBolos(prev => prev.filter(b => b !== id));
}
      const updated = [...readBolos, id];
      setReadBolos(updated);
      localStorage.setItem('readBolos', JSON.stringify(updated));
    
  };

  const formatRemaining = (expiresAt) => {
    const ms = expiresAt - Date.now();
    const minutes = Math.floor(ms / 60000);
    const hours = Math.floor(minutes / 60);
    const remMinutes = minutes % 60;
    return `${hours}h ${remMinutes}m`;
  };

  const goToMessagingWith = (senderId) => {
    navigate(`/messaging?recipient=${senderId}`);
  };


	// --- View mode & filtered display ---
const [viewMode, setViewMode] = useState('bolo'); // 'bolo' or 'intel'

// Unread tracking per type
const hasUnreadBolos = bolos.some(
  (b) => b.type === 'bolo' && !readBolos.includes(b.id)
);
const hasUnreadIntel = bolos.some(
  (b) => b.type === 'intel' && !readBolos.includes(b.id)
);

// Filtered items based on current tab
const filtered = bolos.filter((b) => b.type === viewMode);




  return (
  <div className="active-bolos-container">
    {/* ===== Tabs ===== */}
    <div className="active-inner-tabs">
      <button
        className={`${
          viewMode === 'bolo' ? 'active bolo' : ''
        }`}
        onClick={() => setViewMode('bolo')}
      >
        Active BOLOs
        {hasUnreadBolos && <span className="yellow-dot-tab" />}
      </button>
      <button
        className={`${
          viewMode === 'intel' ? 'active intel' : ''
        }`}
        onClick={() => setViewMode('intel')}
      >
        Active Intel
        {hasUnreadIntel && <span className="yellow-dot-tab" />}
      </button>
    </div>

    {/* ===== Cards Section ===== */}
    {filtered.length === 0 ? (
      <p style={{ textAlign: 'center', color: '#bbb', marginTop: '20px' }}>
        No active {viewMode === 'intel' ? 'Intel notes' : 'BOLOs'} for your agency.
      </p>
    ) : (
      filtered.map((bolo) => (
        <div
          key={bolo.id}
          className={`bolo-card ${bolo.type === 'intel' ? 'intel-card' : 'bolo-card'}`}
          onClick={() => handleExpand(bolo.id)}
        >
          {!readBolos.includes(bolo.id) && <span className="yellow-dot" />}

          <div className="bolo-title-row">
            <h3 className="bolo-title">
              <span className="bolo-title-text">{bolo.title}</span> –{' '}
              <span className="bolo-agency-text">
                {bolo.senderName.split(',')[1].trim()}
              </span>
            </h3>
          </div>

          {!expandedBolos.includes(bolo.id) && (
            <div className="bolo-footer">
              <div className="sender-info">
                <div className="sender-lines">
                  <div className="sender-main">
                    {(() => {
                      const [rankAndName] = bolo.senderName.split(',');
                      const parts = rankAndName.trim().split(' ');
                      const rank = parts.slice(0, -1).join(' ');
                      const name = parts[parts.length - 1];
                      return (
                        <>
                          {rank}{' '}
                          <Link
                            to={`/profile/${bolo.senderId}`}
                            onClick={(e) => e.stopPropagation()}
                            className="profile-link"
                          >
                            {name}
                          </Link>
                        </>
                      );
                    })()}
                  </div>

                  <div className="sender-agency-state">
                    {bolo.senderName.split(',')[1].trim()},{' '}
                    {abbreviateState(bolo.senderName.split(',')[2].trim())}
                  </div>
                </div>
              </div>

              <div className="expiration-timer">
                <div>Expires in:</div>
                <div className="expires-time">
                  {formatRemaining(bolo.expiresAt)}
                </div>
              </div>
            </div>
          )}

          {expandedBolos.includes(bolo.id) && (
            <>
              <div className="bolo-body">
                <div className="bolo-text" style={{ whiteSpace: 'pre-wrap' }}>
                  {bolo.text}
                </div>

                {bolo.attachedFileUrls?.length > 0 && (
                  <div className="bolo-attachments">
                    {bolo.attachedFileUrls.map((url, idx) => (
                      <div key={idx} className="bolo-attachment">
                      <img
  src={url}
  alt={`attachment-${idx}`}
  onClick={(e) => {
    e.stopPropagation();
    setPreviewImage(url);
  }}
  className="bolo-image"
/>

                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="bolo-footer">
                <div className="sender-info">
                  <div className="sender-lines">
                    <div className="sender-main">
                      {(() => {
                        const [rankAndName] = bolo.senderName.split(',');
                        const parts = rankAndName.trim().split(' ');
                        const rank = parts.slice(0, -1).join(' ');
                        const name = parts[parts.length - 1];
                        return (
                          <>
                            {rank}{' '}
                            <Link
                              to={`/profile/${bolo.senderId}`}
                              onClick={(e) => e.stopPropagation()}
                              className="profile-link"
                            >
                              {name}
                            </Link>
                          </>
                        );
                      })()}
                    </div>

                    <div className="sender-agency-state">
                      {bolo.senderName.split(',')[1].trim()},{' '}
                      {abbreviateState(bolo.senderName.split(',')[2].trim())}
                    </div>
                  </div>
                </div>

                <div className="expiration-timer">
                  Expires in: {formatRemaining(bolo.expiresAt)}
                </div>
              </div>
            </>
          )}
        </div>
      ))
    )}

	{previewImage && (
  <div
    className="image-preview-overlay"
    onClick={() => setPreviewImage(null)}
  >
    <div
      className="image-preview-container"
      onClick={(e) => e.stopPropagation()}
    >
      <img src={previewImage} alt="Preview" className="image-preview-full" />
 <button
  className="download-btn"
  onClick={async () => {
    try {
      const result = await saveToGallery(previewImage, { fileName: `bolo_${Date.now()}.jpg` });
      alert(formatSaveMessage(result));
    } catch (err) {
      console.error('Save failed:', err);
      alert('Error: ' + (err.message || JSON.stringify(err)));
    }
  }}
>
  ⬇ Download
</button>



      <button
        className="close-btn"
        onClick={() => setPreviewImage(null)}
      >
        ✖
      </button>
    </div>
  </div>
)}

  </div>
);

};

export default ActiveBolos;
